/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-19 20:38:44 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-02-27 11:09:46
 */
<template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" />
    <div class="docs">
      <h1>{{ st('helpDocs.attributionAuth.h1') }}</h1>

      <h2>{{ st('helpDocs.attributionAuth.h2Access') }}</h2>
      <p>{{ st('helpDocs.attributionAuth.pAccess1') }}</p>
      <p>{{ st('helpDocs.attributionAuth.pAccess2') }}</p>
      <h2>{{ st('helpDocs.attributionAuth.h2Use') }}</h2>
      <p>{{ st('helpDocs.attributionAuth.pUseIntro') }}</p>
      <ul>
        <li>{{ st('helpDocs.attributionAuth.liSeller') }}</li>
        <li>{{ st('helpDocs.attributionAuth.liLink') }}</li>
        <li>
          {{ st('helpDocs.attributionAuth.liReport') }}
          <ul>
            <li>{{ st('helpDocs.attributionAuth.liSub1') }}</li>
            <li>{{ st('helpDocs.attributionAuth.liSub2') }}</li>
            <li>{{ st('helpDocs.attributionAuth.liSub3') }}</li>
            <li>{{ st('helpDocs.attributionAuth.liSub4') }}</li>
            <li>{{ st('helpDocs.attributionAuth.liSub5') }}</li>
            <li>{{ st('helpDocs.attributionAuth.liSub6') }}</li>
          </ul>
        </li>
      </ul>
      <p>{{ st('helpDocs.attributionAuth.pClosing') }}</p>
    </div>
  </div>
</template>
<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
import { useSellerI18n } from '@/composables/useSellerI18n'

const { st } = useSellerI18n()
</script>
